export class FinanceInvoiceAdjustDialogModel {
    constructor(
        public piIds: any
    ) {}
}